import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=c7197bc0&scoped=true&lang=scss"

import exportComponent from "/Users/gigi/Documents/micowell/dalwa/xmai_official_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7197bc0"]])

export default __exports__